import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-v1g_btn_checkbox_seleted",
  "use": "icon-v1g_btn_checkbox_seleted-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-v1g_btn_checkbox_seleted\"><path d=\"m8 16c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8z\" fill=\"#00b279\" /><path d=\"m6 11.5-2.9-2.8c-.2-.2-.3-.5-.3-.7 0-.3.1-.5.3-.7s.5-.3.7-.3c.3 0 .5.1.7.3l2.1 2.1 4.3-4.3c.2-.2.4-.3.7-.3s.5.1.7.3.3.4.3.7-.1.5-.3.7l-5 5c-.2.2-.4.3-.7.3-.2 0-.5-.1-.6-.3z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/v1g_btn_checkbox_seleted.svg
// module id = gvuK
// module chunks = 87